import { handleActions } from 'redux-actions';
import { defaultTwoFactorAuthWidgetState } from './defaults';
import { TwoFactorAuthWidgetData, TwoFactorAuthWidgetStep } from './types';
import { initSecurityPage } from '../../actions';
import { NetworkRequestState } from '../baseTypes';
import {
  submitTwoFactorAuthWidgetStart,
  submitTwoFactorAuthWidgetStartFailure,
  submitTwoFactorAuthWidgetStartSuccess,
  submitTwoFactorAuthWidgetVerifyAuthenticatorFailure,
  submitTwoFactorAuthWidgetVerifyAuthenticatorSuccess,
  submitTwoFactorAuthWidgetRegenerateRecoveryCodesSuccess,
  submitTwoFactorAuthWidgetRegenerateRecoveryCodesFailure,
  submitTwoFactorAuthWidgetResetFailure,
  submitTwoFactorAuthWidgetRegenerateRecoveryCodes,
  submitTwoFactorAuthWidgetReset,
  submitTwoFactorAuthWidgetResetSuccess,
} from './actions';

export default handleActions<TwoFactorAuthWidgetData, any>(
  {
    [initSecurityPage.toString()]: (
      state,
      action: ReturnType<typeof initSecurityPage>
    ) => {
      const twoFactorAuthentication =
        action.payload.data.twoFactorAuthentication;
      if (!twoFactorAuthentication) {
        return state;
      }

      let step = TwoFactorAuthWidgetStep.NotEnabled;
      if (
        twoFactorAuthentication.enabled &&
        twoFactorAuthentication.confirmed
      ) {
        step = TwoFactorAuthWidgetStep.Enabled;
      } else if (
        twoFactorAuthentication.enabled &&
        !twoFactorAuthentication.confirmed
      ) {
        step = TwoFactorAuthWidgetStep.AttachAuthenticator;
      }

      return {
        ...state,
        step: step,
        canEnable: twoFactorAuthentication?.canEnable,
        enabled: twoFactorAuthentication?.enabled,
        confirmed: twoFactorAuthentication?.confirmed,
        secretUrl: twoFactorAuthentication?.secretUrl,
        secret: twoFactorAuthentication?.secret,
        submitRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [submitTwoFactorAuthWidgetStart.toString()]: (
      state,
      action: ReturnType<typeof submitTwoFactorAuthWidgetStart>
    ) => {
      return {
        ...state,
        submitRequest: {
          status: NetworkRequestState.SENT_AND_WAITING_FOR_RESPONSE,
        },
      };
    },
    [submitTwoFactorAuthWidgetStartSuccess.toString()]: (
      state,
      action: ReturnType<typeof submitTwoFactorAuthWidgetStartSuccess>
    ) => {
      return {
        ...state,
        step: TwoFactorAuthWidgetStep.AttachAuthenticator,
        submitRequest: {
          status: NetworkRequestState.IDLE,
        },
        secretUrl: action.payload.secretUrl,
        secret: action.payload.secret,
      };
    },
    [submitTwoFactorAuthWidgetStartFailure.toString()]: (
      state,
      action: ReturnType<typeof submitTwoFactorAuthWidgetStartFailure>
    ) => {
      return {
        ...state,
        submitRequest: {
          status: NetworkRequestState.FAILURE,
          errorMessage: action.payload.errorMessage,
        },
      };
    },
    [submitTwoFactorAuthWidgetVerifyAuthenticatorSuccess.toString()]: (
      state,
      action: ReturnType<
        typeof submitTwoFactorAuthWidgetVerifyAuthenticatorSuccess
      >
    ) => {
      return {
        ...state,
        step: TwoFactorAuthWidgetStep.SuccessWithRecoveryCodes,
        recoveryCodes: action.payload.recoveryCodes,
        submitRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [submitTwoFactorAuthWidgetVerifyAuthenticatorFailure.toString()]: (
      state,
      action: ReturnType<
        typeof submitTwoFactorAuthWidgetVerifyAuthenticatorFailure
      >
    ) => {
      return {
        ...state,
        submitRequest: {
          status: NetworkRequestState.FAILURE,
          errorMessage: action.payload.errorMessage,
        },
      };
    },
    [submitTwoFactorAuthWidgetRegenerateRecoveryCodes.toString()]: (
      state,
      action: ReturnType<
        typeof submitTwoFactorAuthWidgetRegenerateRecoveryCodes
      >
    ) => {
      return {
        ...state,
        submitRequest: {
          status: NetworkRequestState.SENT_AND_WAITING_FOR_RESPONSE,
        },
      };
    },
    [submitTwoFactorAuthWidgetRegenerateRecoveryCodesSuccess.toString()]: (
      state,
      action: ReturnType<
        typeof submitTwoFactorAuthWidgetRegenerateRecoveryCodesSuccess
      >
    ) => {
      return {
        ...state,
        step: TwoFactorAuthWidgetStep.SuccessWithRecoveryCodes,
        recoveryCodes: action.payload.recoveryCodes,
        submitRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [submitTwoFactorAuthWidgetRegenerateRecoveryCodesFailure.toString()]: (
      state,
      action: ReturnType<
        typeof submitTwoFactorAuthWidgetRegenerateRecoveryCodesFailure
      >
    ) => {
      return {
        ...state,
        submitRequest: {
          status: NetworkRequestState.FAILURE,
          errorMessage: action.payload.errorMessage,
        },
      };
    },
    [submitTwoFactorAuthWidgetReset.toString()]: (
      state,
      action: ReturnType<typeof submitTwoFactorAuthWidgetReset>
    ) => {
      return {
        ...state,
        submitRequest: {
          status: NetworkRequestState.SENT_AND_WAITING_FOR_RESPONSE,
        },
      };
    },
    [submitTwoFactorAuthWidgetResetSuccess.toString()]: (
      state,
      action: ReturnType<typeof submitTwoFactorAuthWidgetResetSuccess>
    ) => {
      return {
        ...state,
        step: TwoFactorAuthWidgetStep.NotEnabled,
        submitRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [submitTwoFactorAuthWidgetResetFailure.toString()]: (
      state,
      action: ReturnType<typeof submitTwoFactorAuthWidgetResetFailure>
    ) => {
      return {
        ...state,
        submitRequest: {
          status: NetworkRequestState.FAILURE,
          errorMessage: action.payload.errorMessage,
        },
      };
    },
  },
  defaultTwoFactorAuthWidgetState
);
